<template lang="pug">
  .cart-sub-pending-modal
    SectionTitle(data-mr-ass="are-you-sure").text-center YOUR ORDER IS ON THE WAY!

    p.xs-xsmall.max-at-tweak.xs-mt-200m.xs-mb-100m An order with these items is already being processed and will get to you in 3-7 business days. Do you want to create another order?
    p.xs-xsmall.max-at-tweak.xs-mb-200m If you need it even sooner, please call us at&nbsp;
      MrPhoneLink(:number="$root.MRConfig.contactPhone")

    .row
      SubmitButtons(
        submit-text="Contact Us"
        :submit-method="contactUs"
        cancel-text="Close"
        :cancel-method="hideModal"
      )

</template>

<script>
  import { mapActions } from "vuex";
  import SectionTitle from "../../../SectionTitle";
  import SubmitButtons from "../../../SubmitButtons";
  import MrPhoneLink from "../../../mrPhoneLink";

  export default {
    name: "CartSubPendingModal",
    components: {
      MrPhoneLink,
      SubmitButtons,
      SectionTitle
    },

    methods: {
      ...mapActions('modal', ['hideModal']),

      contactUs() {
        window.location = '/support';
      }
    }
  }
</script>

<style scoped lang="stylus">

</style>